import moment from 'moment';

import CustomerTypingState from 'models/customer_typing_state';
import TypingState from 'models/typing_state';
import { updateCustomerTypingState } from './lib/update_customer_typing_state';

export default class StopCustomerTypingState {
  constructor(context) {
    this.context = context;
  }

  run({ customerId }) {
    const customerTypingState = CustomerTypingState.fromJs({
      state: TypingState.STOPPED,
      timestamp: moment().toISOString(),
    });

    updateCustomerTypingState(this.context, customerId, customerTypingState);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/concurrent_messaging/stop_customer_typing_state.js